<template>
<div class="chapter">
<div class="inner_page">
<p class="left1"><i>“A hippie is someone who looks like Tarzan, walks like Jane, and smells like Cheetah.”</i></p>
<p class="right"><span>—Ronald Reagan</span></p>
<p class="left"><i>“Good morning! What we have in mind is breakfast in bed for 400,000.”</i></p>
<p class="right"><span>—Wavy Gravy at Woodstock</span></p>
<p class="left"><i>“We are not about to send American boys nine or ten thousand miles away from home to do what Asian boys ought to be doing for themselves.”</i></p>
<p class="right"><span>—President Lyndon Johnson</span></p>
<p class="left"><i>“There’s a bad moon on the rise.”</i></p>
<p class="right"><span>—Creedence Clearwater Revival</span></p>
<p class="left"><i>“Tin soldiers and Nixon coming … Four dead in Ohio.”</i></p>
<p class="right"><span>—Neil Young’s “Ohio” about Kent State</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?9cc1bcfa